<template>
    <div class="project-dashboard">
        <div class="card">
            <div class="card-header">
                <span class="card-title p-0 m-0 d-flex align-items-center justify-content-between">
                    <a href="/admin/projects" class="btn btn-sm btn-theme"><i class="bi bi-arrow-left pe-1"></i> Back</a>
                    <a v-if="$hasPermission('manage_projects')" class="btn btn-sm btn-theme cursor-pointer" @click="showMarkCompleteProjectModal"><i class="bi bi-check-circle pe-1"></i> Mark Complete Project</a>
                </span>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-md-7 dashboard">
                        <div class="row">
                            <div class="col-xxl-3 col-md-3 col-sm-6 col-mo-6">
                                <div class="card info-card sales-card bg-success bg-opacity-25">
                                    <div class="card-body d-flex flex-column justify-content-center align-items-center text-center">
                                        <h5 class="card-title pt-1 pb-2 hm-fs-13"><div>Tender Amount</div></h5>
                                        <div class="d-flex align-items-center justify-content-center">
                                            <div class="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                                <i class="bi bi-currency-pound"></i>
                                            </div>
                                            <div class="ps-2">
                                                <h6>{{ currency }}{{ parseFloat(projectData.tender_amount).toFixed(2) }}</h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xxl-3 col-md-3 col-sm-6 col-mo-6">
                                <div class="card info-card sales-card bg-info bg-opacity-25">
                                    <div class="card-body d-flex flex-column justify-content-center align-items-center text-center">
                                        <h5 class="card-title pt-1 pb-2 hm-fs-13"><div>Extra Approved</div></h5>
                                        <div class="d-flex align-items-center justify-content-center">
                                            <div class="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                                <i class="bi bi-currency-pound"></i>
                                            </div>
                                            <div class="ps-2">
                                                <h6>{{ currency }}{{ parseFloat(extraApprovedAmount).toFixed(2) }}</h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xxl-3 col-md-3 col-sm-6 col-mo-6">
                                <div class="card info-card sales-card bg-warning bg-opacity-25">
                                    <div class="card-body d-flex flex-column justify-content-center align-items-center text-center">
                                        <h5 class="card-title pt-1 pb-2 hm-fs-13"><div>Total Amount</div></h5>
                                        <div class="d-flex align-items-center justify-content-center">
                                            <div class="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                                <i class="bi bi-bank"></i>
                                            </div>
                                            <div class="ps-2">
                                                <h6>{{ currency }}{{ parseFloat(totalCost).toFixed(2) }}</h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xxl-3 col-md-3 col-sm-6 col-mo-6">
                                <div class="card info-card sales-card bg-danger bg-opacity-25">
                                    <div class="card-body d-flex flex-column justify-content-center align-items-center text-center">
                                        <h5 class="card-title pt-1 pb-2 hm-fs-13"><div>Balance Amount</div></h5>
                                        <div class="d-flex align-items-center justify-content-center">
                                            <div class="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                                <i class="bi bi-bank"></i>
                                            </div>
                                            <div class="ps-2">
                                                <h6>{{ currency }}{{ parseFloat(totalCost-totalMaterialStaffCost).toFixed(2) }}</h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xxl-3 col-md-3 col-sm-6 col-mo-6">
                                <div class="card info-card sales-card bg-success bg-opacity-25">
                                    <div class="card-body d-flex flex-column justify-content-center align-items-center text-center">
                                        <h5 class="card-title pt-1 pb-2 hm-fs-13"><div>Head Count</div></h5>
                                        <div class="d-flex align-items-center justify-content-center">
                                            <div class="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                                <i class="bi bi-people"></i>
                                            </div>
                                            <div class="ps-2">
                                                <h6>{{ totalHeadCount || 0 }}</h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xxl-3 col-md-3 col-sm-6 col-mo-6">
                                <div class="card info-card sales-card bg-info bg-opacity-25">
                                    <div class="card-body d-flex flex-column justify-content-center align-items-center text-center">
                                        <h5 class="card-title pt-1 pb-2 hm-fs-13"><div>Material Cost</div></h5>
                                        <div class="d-flex align-items-center justify-content-center">
                                            <div class="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                                <i class="bi bi-currency-pound"></i>
                                            </div>
                                            <div class="ps-2">
                                                <h6>{{ currency }}{{ parseFloat(totalItemCost).toFixed(2) }}</h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xxl-3 col-md-3 col-sm-6 col-mo-6">
                                <div class="card info-card sales-card bg-warning bg-opacity-25">
                                    <div class="card-body d-flex flex-column justify-content-center align-items-center text-center">
                                        <h5 class="card-title pt-1 pb-2 hm-fs-13"><div>Staff Cost</div></h5>
                                        <div class="d-flex align-items-center justify-content-center">
                                            <div class="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                                <i class="bi bi-currency-pound"></i>
                                            </div>
                                            <div class="ps-2">
                                                <h6>{{ currency }}{{ parseFloat(totalLabourCost).toFixed(2) }}</h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-xxl-3 col-md-3 col-sm-6 col-mo-6">
                                <div class="card info-card sales-card bg-danger bg-opacity-25">
                                    <div class="card-body d-flex flex-column justify-content-center align-items-center text-center">
                                        <h5 class="card-title pt-1 pb-2 hm-fs-13"><div>Total Spend</div></h5>
                                        <div class="d-flex align-items-center justify-content-center">
                                            <div class="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                                <i class="bi bi-currency-pound"></i>
                                            </div>
                                            <div class="ps-2">
                                                <h6>{{ currency }}{{ parseFloat(totalMaterialStaffCost).toFixed(2) }}</h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Invoiced amount -->
                            <div class="col-xxl-3 col-md-3 col-sm-6 col-mo-6">
                                <div class="card info-card sales-card bg-primary bg-opacity-25">
                                    <div class="card-body d-flex flex-column justify-content-center align-items-center text-center">
                                        <h5 class="card-title pt-1 pb-2 hm-fs-13"><div>Invoiced Amount</div></h5>
                                        <div class="d-flex align-items-center justify-content-center">
                                            <div class="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                                <i class="bi bi-bank"></i>
                                            </div>
                                            <div class="ps-2">
                                                <h6>{{ currency }}{{ parseFloat(totalInvoicedAmount).toFixed(2) }}</h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xxl-3 col-md-3 col-sm-6 col-mo-6">
                                <div class="card info-card sales-card bg-primary bg-opacity-25">
                                    <div class="card-body d-flex flex-column justify-content-center align-items-center text-center">
                                        <h5 class="card-title pt-1 pb-2 hm-fs-13"><div>Pending Invoice Amount</div></h5>
                                        <div class="d-flex align-items-center justify-content-center">
                                            <div class="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                                <i class="bi bi-bank"></i>
                                            </div>
                                            <div class="ps-2">
                                                <h6>{{ currency }}{{ parseFloat(pendingInvoiceAmount).toFixed(2) }}</h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-5 profile">
                        <div class="row g-3 profile-overview">
                            <div class="col-md-6 col-mo-6">
                                <label class="label">Tender Amount</label>
                                <div>{{ currency }}{{ parseFloat(projectData.tender_amount).toFixed(2) }}</div>
                            </div>
                            <div class="col-md-6 col-mo-6">
                                <label class="label">Extra Approved</label>
                                <div class="text-capitalize">{{ currency }}{{ parseFloat(extraApprovedAmount).toFixed(2) }}</div>
                            </div>
                            <div class="col-md-6 col-mo-6">
                                <label class="label">Project Name</label>
                                <div class="">{{ projectData.name }}</div>
                            </div>
                            <div class="col-md-6 col-mo-6">
                                <label class="label">Client Name</label>
                                <div class="text-truncate">{{ projectData.customer_name }}</div>
                            </div>
                            <div class="col-md-6 col-mo-6">
                                <label class="label">Client Email</label>
                                <div class="text-truncate">{{ projectData.customer_email }}</div>
                            </div>
                            <div class="col-md-6 col-mo-6">
                                <label class="label">Client Phone</label>
                                <div>{{ projectData.customer_phone }}</div>
                            </div>
                            <div class="col-md-6 col-mo-6">
                                <label class="label">Address</label>
                                <div>{{ projectData.address }}</div>
                            </div>
                            <div class="col-md-6 col-mo-6">
                                <label class="label">Postal Code</label>
                                <div>{{ projectData.postal_code }}</div>
                            </div>
                            <div class="col-md-6 col-mo-6">
                                <label class="label">Start Date</label>
                                <div>{{ $dateTimeFormat(projectData.start_at, 'DD/MM/YYYY') }}</div>
                            </div>
                            <div class="col-md-6 col-mo-6">
                                <label class="label">End Date</label>
                                <div>{{ $dateTimeFormat(projectData.ends_at, 'DD/MM/YYYY') }}</div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <!-- Display Project invoices -->
        <ProjectInvoice :project="projectData"></ProjectInvoice>

        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <span class="card-title p-0 m-0">Project Staff <button v-if="$hasPermission('manage_projects')" class="btn btn-sm btn-theme float-end" @click="showAddStaffModal"><i class="bi bi-plus-circle pe-1"></i> Add Staff</button></span>
                    </div>
                    <div class="card-body">
                        <!-- <table class="table align-middle datatable w-100" id="projectStaffTable">
                            <thead>
                                <tr>
                                    <th scope="col" class="text-center">Date</th>
                                    <th scope="col" class="text-center">Labour Cost</th>
                                    <th scope="col" class="text-center"># of Staff</th>
                                    <th scope="col">Staff Name</th>
                                </tr>
                            </thead>
                        </table> -->

                        <Vue3EasyDataTable
                            ref="staffTable"
                            v-model:server-options="staffDataTableObj.serverOptions"
                            :headers="staffDataTableObj.headers"
                            :items="staffDataTableObj.items"
                            :loading="staffDataTableObj.loading"
                            :server-items-length="staffDataTableObj.totalItems"
                            :server-options="staffDataTableObj.serverOptions"
                            header-text-direction="center"
                            body-text-direction="center"
                            buttons-pagination
                            theme-color="#1d90ff"
                            table-class-name="hm-easy-table"
                            @update:server-options="projectStaffDataTable"
                        >
                            <template #item-work_date="item">
                                {{ $dateTimeFormat(item.work_date, 'DD/MM/YYYY') }}
                            </template>
                            <template #item-labour_cost="item">
                                {{ currency }}{{ parseFloat(item.labour_cost).toFixed(2) }}
                            </template>
                            <template #item-action="item">
                                <span @click="editStaff(item)" class="cursor-pointer me-2">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-square-pen"><path d="M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.375 2.625a1 1 0 0 1 3 3l-9.013 9.014a2 2 0 0 1-.853.505l-2.873.84a.5.5 0 0 1-.62-.62l.84-2.873a2 2 0 0 1 .506-.852z"/></svg>
                                </span>
                                <span @click="deleteStaffItem(item)" class="cursor-pointer">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-trash-2"><path d="M3 6h18"/><path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/><path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/><line x1="10" x2="10" y1="11" y2="17"/><line x1="14" x2="14" y1="11" y2="17"/></svg>
                                </span>
                            </template>
                        </Vue3EasyDataTable>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <div class="card">
                    <div class="card-header">
                        <span class="card-title p-0 m-0">Project Materials <button v-if="$hasPermission('manage_projects')" class="btn btn-sm btn-theme float-end" @click="showAddMaterialModal"><i class="bi bi-plus-circle pe-1"></i> Add Material</button></span>
                    </div>
                    <div class="card-body">
                        <Vue3EasyDataTable
                            ref="materialsTable"
                            v-model:server-options="materialsDataTableObj.serverOptions"
                            :headers="materialsDataTableObj.headers"
                            :items="materialsDataTableObj.items"
                            :loading="materialsDataTableObj.loading"
                            :server-items-length="materialsDataTableObj.totalItems"
                            :server-options="materialsDataTableObj.serverOptions"
                            header-text-direction="center"
                            body-text-direction="center"
                            buttons-pagination
                            theme-color="#1d90ff"
                            table-class-name="hm-easy-table"
                            @update:server-options="projectMaterialsTable"
                        >
                            <template #item-created_at="item">
                                {{ $dateTimeFormat(item.created_at, 'DD/MM/YYYY') }}
                            </template>
                            <template #item-total_amount="item">
                                {{ currency }}{{ parseFloat(item.total_amount).toFixed(2) }}
                            </template>
                            <template #item-action="item">
                                <span @click="editMaterial(item)" class="cursor-pointer me-2">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-square-pen"><path d="M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.375 2.625a1 1 0 0 1 3 3l-9.013 9.014a2 2 0 0 1-.853.505l-2.873.84a.5.5 0 0 1-.62-.62l.84-2.873a2 2 0 0 1 .506-.852z"/></svg>
                                </span>
                                <span @click="deleteMaterial(item)" class="cursor-pointer">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-trash-2"><path d="M3 6h18"/><path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/><path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/><line x1="10" x2="10" y1="11" y2="17"/><line x1="14" x2="14" y1="11" y2="17"/></svg>
                                </span>
                            </template>
                        </Vue3EasyDataTable>
                    </div>
                </div>
            </div>
            <!-- Additional approved materials -->
            <div class="col-md-6">
                <div class="card">
                    <div class="card-header">
                        <span class="card-title p-0 m-0">Extra Approved <button v-if="$hasPermission('manage_projects')" class="btn btn-sm btn-theme float-end" @click="showAddApprovedItemModal()"><i class="bi bi-plus-circle pe-1"></i> Add Extra</button></span>
                    </div>
                    <div class="card-body">
                        <Vue3EasyDataTable
                            ref="extraApprovedTable"
                            v-model:server-options="extraApprovedDataTableObj.serverOptions"
                            :headers="extraApprovedDataTableObj.headers"
                            :items="extraApprovedDataTableObj.items"
                            :loading="extraApprovedDataTableObj.loading"
                            :server-items-length="extraApprovedDataTableObj.totalItems"
                            :server-options="extraApprovedDataTableObj.serverOptions"
                            header-text-direction="center"
                            body-text-direction="center"
                            buttons-pagination
                            theme-color="#1d90ff"
                            table-class-name="hm-easy-table"
                            @update:server-options="projectExtraApprovedTable"
                        >
                            <template #item-created_at="item">
                                {{ $dateTimeFormat(item.created_at, 'DD/MM/YYYY') }}
                            </template>
                            <template #item-total_price="item">
                                {{ currency }}{{ parseFloat(item.total_price).toFixed(2) }}
                            </template>
                            <template #item-action="item">
                                <span @click="editApprovedItem(item)" class="cursor-pointer me-2">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-square-pen"><path d="M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.375 2.625a1 1 0 0 1 3 3l-9.013 9.014a2 2 0 0 1-.853.505l-2.873.84a.5.5 0 0 1-.62-.62l.84-2.873a2 2 0 0 1 .506-.852z"/></svg>
                                </span>
                                <span @click="deleteApprovedItem(item)" class="cursor-pointer">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-trash-2"><path d="M3 6h18"/><path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/><path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/><line x1="10" x2="10" y1="11" y2="17"/><line x1="14" x2="14" y1="11" y2="17"/></svg>
                                </span>
                            </template>
                        </Vue3EasyDataTable>
                    </div>
                </div>
            </div>
        </div>

        <!-- Project Activity -->
        <div v-if="projectData.activities.length > 0" class="row project-activity">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <span class="card-title p-0 m-0">Project Activity</span>
                    </div>
                    <div class="card-body dashboard">
                        <div class="activity scroll-area">

                            <div
                                v-for="(activity, index) in projectData.activities"
                                class="activity-item d-flex"
                            >
                                <div class="activite-label hm-fs-12 text-end pe-2 pb-3 text-black">
                                    <div>{{ $dateTimeFormat(activity.created_at, 'DD MMM, YYYY') }}</div>
                                    <div>{{ $dateTimeFormat(activity.created_at, 'hh:mm A') }}</div>
                                    <div class="d-inline-block text-truncate" style="max-width: 90px;">By {{ activity?.user?.first_name }}</div>
                                </div>
                                <i class="bi bi-circle-fill activity-badge text-theme align-self-start"></i>
                                <div class="activity-content">
                                    <div class="text-capitalize hm-fs-12 text-black fw-bold">{{ activity.action.replace(/_/g, ' ') }}</div>
                                    <div v-if="['project_created', 'project_updated'].includes(activity.action) && activity.data?.project?.tender_amount" class="hm-fs-12 text-black">
                                        Tender Amount: {{ currency }}{{ activity.data?.project?.tender_amount }}
                                    </div>
                                    <div v-if="activity.comment && activity.comment.trim() !== ''" class="hm-fs-12 text-black">{{ activity.comment }}</div>
                                    <!-- Display staff notes -->
                                    <div v-if="activity.data?.staff?.notes" class="hm-fs-12 text-black">{{ activity.data?.staff?.notes }}</div>

                                    <!-- Display materials notes -->
                                    <div v-if="activity.data?.materials?.notes" class="hm-fs-12 text-black">
                                        {{ activity.data?.materials?.notes }}
                                        <br>
                                        Amount: {{ currency }}{{ activity.data?.materials?.amount }}
                                    </div>

                                    <!-- Display extra notes -->
                                    <div v-if="activity.data?.extra_approved?.notes" class="hm-fs-12 text-black">
                                        {{ activity.data?.extra_approved?.notes }}
                                        <br>
                                        Amount: {{ currency }}{{ activity.data?.extra_approved?.amount }}
                                    </div>

                                    <!-- Check if document is uploaded -->
                                    <div v-if="activity.data?.extra_approved?.document && activity.data?.extra_approved?.document !== ''"
                                        class="col-md-12 d-flex flex-row flex-wrap"
                                    >
                                        <div class="image-preview-row d-flex flex-row flex-wrap">
                                            <a
                                                :href="$baseUrl + '/uploads/projects/' + activity.data?.extra_approved?.document"
                                                target="_blank"
                                                class="order-img-slides"
                                            >
                                                <img
                                                    :src="prepareImageSource(activity.data.extra_approved)"
                                                    class="img-thumbnail me-2 mb-2 cursor-pointer"
                                                    style="max-height: 150px; max-width: 150px;"
                                                />
                                            </a>
                                        </div>
                                    </div>
                                    <!-- Display order logs -->
                                    <div
                                        v-if="activity.data && activity.data?.logs"
                                        v-for="(item, index) in activity.data?.logs"
                                        :key="index"
                                        class="hm-fs-12 text-black"
                                    >
                                        <div>{{ item.value }}</div>
                                        <div v-if="item.comment && item.comment !== ''">{{ item.comment }}</div>
                                        <!-- <template v-if="item.amount">
                                            <br/>
                                            Amount: {{ currency }}{{ item.amount }}
                                        </template> -->
                                    </div>

                                    <!-- Display project images -->
                                    <div v-if="activity.data && activity.data.images" class="mt-2 d-flex flex-wrap gap-2">
                                        <div v-for="(img, idx) in activity.data.images" :key="idx" class="history-image">
                                            <a :href="getImageUrl(img)" class="order-img-slides">
                                                <img :src="getImagePreview(img)" class="img-thumbnail rounded-3" style="width: 60px; height: 60px; object-fit: cover;">
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- End activity item-->
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Add projects staff -->
        <div
            class="modal fade"
            id="addStaffModal"
            aria-labelledby="addStaffModal"
            aria-hidden="true"
        >
            <div class="modal-dialog modal-lg">
                <Form :validation-schema="attachStaffSchema" v-slot="{ handleSubmit, errors }" as="div">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Add Project Staff</h5>
                            <button
                                type="button"
                                class="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <div class="modal-body">
                            <div class="row g-3">
                                <div class="col-md-3">
                                    <label for="work_date" class="form-label">Work Date <span class="text-danger">*</span></label>
                                    <div class="d-flex align-items-center">
                                        <BookingDatePicker
                                            v-model="attachStaffWithProject.work_date"
                                            :format="'dd-MM-yyyy'"
                                            :time-picker="false"
                                            :location="'project'"
                                            :auto-apply="true"
                                        />
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <label for="staff" class="form-label">Select Staff</label>
                                    <Field
                                        name="staff"
                                        :value="attachStaffWithProject.user_id"
                                        v-slot="{ field }"
                                    >
                                        <vue-multiselect
                                            v-bind="field"
                                            v-model="attachStaffWithProject.staff"
                                            :options="handymanList"
                                            placeholder="Select user"
                                            :taggable="false"
                                            :show-labels="false"
                                            track-by="id"
                                            label="name"
                                            :multiple="true"
                                            @select="selectStaffUser($event, index)"
                                            @remove="removeStaffUser($event, index)"
                                        ></vue-multiselect>
                                    </Field>
                                </div>
                                <div class="col-md-3">
                                    <label for="labour_cost" class="form-label">Labour Cost <span class="text-danger">*</span></label>
                                    <Field
                                        as="input"
                                        type="text"
                                        name="labour_cost"
                                        class="form-control bg-white"
                                        :class="{ 'is-invalid': errors[`labour_cost`] }"
                                        placeholder="Enter labour cost"
                                        v-model="attachStaffWithProject.labour_cost"
                                        @input="handleNumberInput($event, index, 'staff')"
                                    ></Field>
                                    <div class="is-invalid invalid-feedback">{{ errors.labour_cost }}</div>
                                </div>
                                <div class="col-md-12">
                                    <label for="description" class="form-label">Description</label>
                                    <div class="input-group mb-3">
                                        <Field
                                            as="textarea"
                                            name="description"
                                            class="form-control bg-white"
                                            rows="3"
                                            placeholder="Enter note"
                                            v-model="attachStaffWithProject.description"
                                            :class="{ 'is-invalid': errors.description }"
                                        ></Field>
                                        <div class="is-invalid invalid-feedback">This field is required.</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-danger" data-bs-dismiss="modal">Close</button>
                            <button
                                type="submit"
                                class="btn btn-theme"
                                v-text="isProcessing ? 'Processing...' : 'Add Staff'"
                                :disabled="isProcessing"
                                :class="{'disabled': isProcessing}"
                                @click="handleSubmit($event, addProjectStaff)"
                            >
                            </button>
                        </div>
                    </div>
                </Form>
            </div>
        </div>

        <!-- Attach materials with project -->
        <div
            class="modal fade"
            id="attachMaterialsModal"
            aria-labelledby="attachMaterialsModal"
            aria-hidden="true"
        >
            <div class="modal-dialog modal-lg">
                <Form :validation-schema="attachMaterialSchema" v-slot="{ handleSubmit, errors }" as="div">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Add Material</h5>
                            <button
                                type="button"
                                class="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <div class="modal-body">
                            <div class="row g-3">
                                <template v-for="(item, index) in attachItemWithProject">
                                    <div class="col-md-5">
                                        <label :for="`date_${index}`" class="form-label">Date <span class="text-danger">*</span></label>
                                        <Field
                                            class="d-flex align-items-center"
                                            :name="`attachItemWithProject[${index}].date`"
                                            :class="{ 'is-invalid': errors[`attachItemWithProject[${index}].date`] }"
                                        >
                                            <VueDatePicker
                                                v-model="item.date"
                                                :enable-time-picker="false"
                                                :format="'dd-MM-yyyy'"
                                                :min-date="projectData.start_date"
                                                :max-date="projectData.end_date"
                                                :clearable="false"
                                            >
                                            </VueDatePicker>
                                        </Field>
                                        <div class="is-invalid invalid-feedback">This field is required.</div>
                                    </div>
                                    <div class="col-md-6" :class="{'pe-5': (attachItemWithProject.length > 1 && attachItemWithProject.length <= 10)}">
                                        <label :for="`material_cost_${index}`" class="form-label">Material Cost <span class="text-danger">*</span></label>
                                        <Field
                                            as="input"
                                            type="text"
                                            :name="`attachItemWithProject[${index}].material_cost`"
                                            class="form-control bg-white"
                                            :class="{ 'is-invalid': errors[`attachItemWithProject[${index}].material_cost`] }"
                                            placeholder="Enter material cost"
                                            v-model="item.material_cost"
                                            @input="handleNumberInput($event, index, 'material')"
                                        ></Field>
                                        <div class="is-invalid invalid-feedback">This field is required.</div>
                                    </div>
                                    <div class="col-md-1">
                                        <label for="" class="form-label">&nbsp;</label>
                                        <div class="d-flex justify-content-end">
                                            <button v-if="attachItemWithProject.length > 1" type="button" class="btn btn-danger ms-2" @click="removeMaterial(index)"><i class="bi bi-trash"></i></button>
                                            <button v-if="attachItemWithProject.length <= 10" type="button" class="btn btn-theme ms-2" @click="addMoreMaterial"><i class="bi bi-plus-circle"></i></button>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <label for="description" class="form-label">Description</label>
                                        <div class="input-group mb-3">
                                            <Field
                                                as="textarea"
                                                :name="`attachItemWithProject[${index}].description`"
                                                class="form-control bg-white"
                                                rows="3"
                                                placeholder="Enter note"
                                                v-model="item.description"
                                                :class="{ 'is-invalid':errors[`attachItemWithProject[${index}].description`] }"
                                            ></Field>
                                            <div class="is-invalid invalid-feedback">This field is required.</div>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-danger" data-bs-dismiss="modal">Close</button>
                            <button
                                type="submit"
                                class="btn btn-theme"
                                v-text="isProcessing ? 'Processing...' : 'Add Material'"
                                :disabled="isProcessing"
                                :class="{'disabled': isProcessing}"
                                @click="handleSubmit($event, attachMaterialWithProject)"
                            >
                            </button>
                        </div>
                    </div>
                </Form>
            </div>
        </div>

        <!-- Attach additional materials with project -->
        <div
            class="modal fade"
            id="additionalMaterialsModal"
            aria-labelledby="additionalMaterialsModal"
            aria-hidden="true"
        >
            <div class="modal-dialog modal-lg">
                <Form :validation-schema="attachAdditionalMaterialSchema" v-slot="{ handleSubmit, errors }" as="div">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Add Extra</h5>
                            <button
                                type="button"
                                class="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <div class="modal-body">
                            <div class="row g-3">
                                <template v-for="(item, index) in addExtraItems.items">
                                    <div class="col-md-5">
                                        <label for="work_date" class="form-label">Date <span class="text-danger">*</span></label>
                                        <div class="d-flex align-items-center">
                                            <VueDatePicker
                                                v-model="item.date"
                                                :enable-time-picker="false"
                                                :format="'dd-MM-yyyy'"
                                                :min-date="projectData.start_date"
                                                :max-date="projectData.end_date"
                                                :clearable="false"
                                            >
                                            </VueDatePicker>
                                        </div>
                                    </div>
                                    <div class="col-md-6" :class="{'pe-5': (addExtraItems.items.length > 1 && addExtraItems.items.length <= 10)}">
                                        <label :for="'labour_cost' + index" class="form-label">Approved Amount <span class="text-danger">*</span></label>
                                        <Field
                                            as="input"
                                            type="text"
                                            :name="`attachAdditionalItemWithProject[${index}].material_cost`"
                                            class="form-control bg-white"
                                            :class="{ 'is-invalid': errors[`attachAdditionalItemWithProject[${index}].material_cost`] }"
                                            placeholder="Enter amount"
                                            v-model="item.material_cost"
                                            @input="handleNumberInput($event, index, 'additionalItem')"
                                        ></Field>
                                        <div class="is-invalid invalid-feedback">This field is required.</div>
                                    </div>
                                    <div class="col-md-1">
                                        <label for="" class="form-label">&nbsp;</label>
                                        <div class="d-flex justify-content-end">
                                            <button v-if="addExtraItems.items.length > 1" type="button" class="btn btn-danger ms-2" @click="removeAdditionalMaterial(index)"><i class="bi bi-trash"></i></button>
                                            <button v-if="addExtraItems.items.length <= 10" type="button" class="btn btn-theme ms-2" @click="addMoreAdditionalMaterial"><i class="bi bi-plus-circle"></i></button>
                                        </div>
                                    </div>
                                    <div class="col-md-11" :class="{'pe-5': (addExtraItems.items.length > 1 && addExtraItems.items.length <= 10)}">
                                        <label for="description" class="form-label">Description</label>
                                        <div class="input-group mb-3">
                                            <Field
                                                as="textarea"
                                                :name="`attachAdditionalItemWithProject[${index}].description`"
                                                class="form-control bg-white"
                                                rows="3"
                                                placeholder="Enter note"
                                                v-model="item.description"
                                                :class="{ 'is-invalid':errors[`attachAdditionalItemWithProject[${index}].description`] }"
                                            ></Field>
                                            <div class="is-invalid invalid-feedback">This field is required.</div>
                                        </div>
                                    </div>
                                </template>
                                <div class="col-md-11" :class="{'pe-5': (addExtraItems.items.length > 1 && addExtraItems.items.length <= 10)}">
                                    <label for="description" class="form-label">Attachment</label>
                                    <div class="input-group mb-3">
                                        <input
                                            type="file"
                                            name="file"
                                            id="file"
                                            ref="fileInput"
                                            class="form-control bg-white"
                                            accept = "application/pdf,.csv,.txt,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel,image/*"
                                            @change="onFileChange"
                                        >
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-danger" data-bs-dismiss="modal">Close</button>
                            <button
                                type="button"
                                class="btn btn-theme"
                                v-text="isProcessing ? 'Processing...' : 'Add Extra'"
                                :disabled="isProcessing"
                                :class="{'disabled': isProcessing}"
                                @click="handleSubmit($event, attachAdditionalMaterialWithProject)"
                            >
                            </button>
                        </div>
                    </div>
                </Form>
            </div>
        </div>

        <!-- Mark project complete -->
        <div
            class="modal fade"
            id="markProjectCompleteModal"
            aria-labelledby="markProjectCompleteModal"
            aria-hidden="true"
        >
            <div class="modal-dialog modal-lg">
                <Form :validation-schema="updateProjectSchema" v-slot="{ handleSubmit, errors }" as="div">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Mark Project Completed</h5>
                            <button
                                type="button"
                                class="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <div class="modal-body">
                            <div class="row g-3">
                                <div class="col-md-12">
                                    <label for="description" class="form-label">Prject Completion Note</label>
                                    <div class="input-group mb-3">
                                        <Field
                                            as="textarea"
                                            name="projectCompletionNote"
                                            class="form-control bg-white"
                                            rows="5"
                                            placeholder="Enter note"
                                            v-model="projectCompletionNote"
                                            :class="{ 'is-invalid': errors.projectCompletionNote }"
                                        ></Field>
                                        <div class="is-invalid invalid-feedback">This field is required.</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-danger" data-bs-dismiss="modal">Close</button>
                            <button
                                type="button"
                                class="btn btn-theme"
                                v-text="isProcessing ? 'Processing...' : 'Complete'"
                                :disabled="isProcessing"
                                :class="{'disabled': isProcessing}"
                                @click="handleSubmit($event, markProjectComplete)"
                            >
                            </button>
                        </div>
                    </div>
                </Form>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import { appMixin } from "../mixin/appMixin";
import BookingDatePicker from "./BookingDatePicker";
import ProjectInvoice from "./Project/ProjectInvoice";

export default {
    name: 'ProjectDashboard',
    mixins: [appMixin],
    props: {
        project: {
            type: Object,
            required: true
        }
    },
    components: {
        BookingDatePicker,
        ProjectInvoice
    },
    data() {
        return {
            isProcessing: false,
            projectData: this.project,
            projectUsers: this.project.users,
            projectItems: this.project.items,
            projectAdditionalItems: this.project.additional_items,
            attachItemWithProject:[
                {
                    id: '',
                    service_id: '',
                    service_name: '',
                    amount: '',
                    discount: '',
                    labour_cost: '',
                    tax: '',
                    total_amount: '',
                    date: new Date(),
                    material_cost: '',
                    name: '',
                    description: '',
                }
            ],
            addExtraItems: {
                files: [],
                items: [
                    {
                        id: '',
                        name: '',
                        description: '',
                        date: new Date(),
                        material_cost: '',
                    }
                ],
            },
            attachAdditionalItemWithProject: [
                {
                    service_id: '',
                    name: '',
                    description: '',
                    amount: '',
                    discount: '',
                    Labour_cost: '',
                    tax: '',
                    total_amount: '',
                    date: new Date(),
                    material_cost: '',
                }
            ],
            attachStaffWithProject: {
                edit: false,
                staff_ids: [],
                user_ids: [],
                user_id: null,
                name: '',
                email: '',
                amount: 0,
                discount: 0,
                labour_cost: 0,
                tax: 0,
                total_amount: 0,
                work_date: new Date().toISOString(),
                staff: null,
                batch: null,
                description: ''
            },
            staffUsersOptions: [],
            staffDataTable: null,
            projectMaterialsDataTable: null,
            projectExtraApprovedDataTable: null,
            //handymanSchedules: [],
            materialsDataTableObj: {
                loading: true,
                totalItems: 0,
                serverOptions: {
                    page: 1,
                    rowsPerPage: 5,
                    sortBy: 'created_at',
                    sortType: 'desc',
                },
                headers: [
                    {text: "Date", value: "created_at", sortable: true},
                    {text: "Material Cost", value: "total_amount", sortable: true},
                    {text: "Action", value: "action", sortable: false},
                ],
                items: []
            },
            extraApprovedDataTableObj: {
                loading: true,
                totalItems: 0,
                serverOptions: {
                    page: 1,
                    rowsPerPage: 5,
                    sortBy: 'created_at',
                    sortType: 'desc',
                },
                headers: [
                    {text: "Date", value: "created_at", sortable: true},
                    {text: "Extra Amount", value: "total_price", sortable: true},
                    {text: "Action", value: "action", sortable: false},
                ],
                items: []
            },
            staffDataTableObj: {
                loading: true,
                totalItems: 0,
                serverOptions: {
                    page: 1,
                    rowsPerPage: 5,
                    sortBy: 'work_date',
                    sortType: 'desc',
                },
                headers: [
                    {text: "Date", value: "work_date", sortable: true},
                    {text: "Labour Cost", value: "labour_cost", sortable: true},
                    {text: "Head Count", value: "user_count", sortable: true},
                    {text: "Users", value: "user_names", sortable: true},
                    {text: "Action", value: "action", sortable: false},
                ],
                items: []
            },
            projectCompletionNote: '',
            totalInvoicedAmount: 0,
            handymanList: [],
        }
    },
    mounted() {
        //this.getStaffUsers();
        this.projectStaffDataTable();
        this.projectMaterialsTable();
        this.projectExtraApprovedTable();

        // Get handyman booked schedules
        //this.getHandymanBookedSchedules();
        this.$store.dispatch('fetchBookedSchedules');

        /* this.$emitter.on('hmSchedulesFetched', (data) => {
            this.handymanSchedules = data.schedules;
            this.prepareStaffOptions();
        }); */

        this.getProjectDetails();
    },
    computed: {
        currency() {
            return this.$store.getters.getSystemSettings.currency.symbol || '£';
        },
        attachStaffSchema() {
            return {
                labour_cost: {
                    required: true,
                    min_value: 0,
                    regex: /^(\d+(\.\d{1,2})?)$/
                },
                description: 'required',
            };
        },
        attachMaterialSchema() {
            let schema = {};
            this.attachItemWithProject.forEach((item, index) => {
                //schema[`attachItemWithProject.${index}.date`] = 'required';
                schema[`attachItemWithProject.${index}.material_cost`] = {
                    required: true,
                    min_value: 0,
                    regex: /^(\d+(\.\d{1,2})?)$/
                };
                schema[`attachItemWithProject.${index}.description`] = 'required';
            });
            return schema;
        },
        attachAdditionalMaterialSchema() {
            let schema = {};
            this.addExtraItems.items.forEach((item, index) => {
                schema[`attachAdditionalItemWithProject.${index}.material_cost`] = {
                    required: true,
                    min_value: 0,
                    regex: /^(\d+(\.\d{1,2})?)$/
                };
                schema[`attachAdditionalItemWithProject.${index}.description`] = 'required';
            });
            return schema;
        },
        totalLabourCost() {
            return this.projectUsers.reduce((sum, user) => parseFloat(sum) + parseFloat(user.labour_cost), 0);
        },
        totalItemCost() {
            return this.projectItems.reduce((sum, item) => parseFloat(sum) + parseFloat(item.amount), 0);
        },
        extraApprovedAmount() {
            return this.projectAdditionalItems.reduce((sum, item) => parseFloat(sum) + parseFloat(item.total_price), 0);
        },
        totalCost() {
            return parseFloat(this.extraApprovedAmount) + parseFloat(this.projectData.tender_amount);
        },
        totalMaterialStaffCost() {
            return this.totalItemCost + this.totalLabourCost;
        },
        totalHeadCount() {
            return this.projectUsers.reduce((sum, user) => {
                return parseFloat(sum) + parseFloat(user.user_count === 0 ? 1 : user.user_count);
            }, 0);
        },
        staffOptionsForProject() {
            let options = [];
            this.attachStaffWithProject.staff = null;
            const projectUserIds = this.attachStaffWithProject.user_ids;

            const dateToFind = this.$dateTimeFormat(this.$moment(this.attachStaffWithProject.work_date).utc(), 'YYYY-MM-DD');
            // First, create a map of handymen who are already booked for this date
            const bookedHandymen = new Set();
            this.bookedSchedules.forEach(handyman => {
                handyman.handymanSchedules.forEach(schedule => {
                    if (schedule.schedule_date === dateToFind && schedule.orders && schedule.orders.length > 0) {
                        bookedHandymen.add(handyman.id);
                    }
                });
            });

            Object.keys(this.handymanSchedules).forEach((handymanId) => {
                // Skip if handyman is already booked for this date
                if (bookedHandymen.has(parseInt(handymanId)) && !projectUserIds.includes(parseInt(handymanId))) {
                    return;
                }
                this.handymanSchedules[handymanId].forEach((schedule) => {
                    if (schedule.schedule_date === dateToFind) {
                        let exists = options.some(function(option) {
                            return option.id === schedule.handyman_id;
                        });

                        // If it doesn't exist, push the new option
                        // If user projectUserIds contains handyman id or schedule status is available
                        if (!exists && (schedule.status === 'available' || projectUserIds.includes(schedule.handyman_id))) {
                            options.push({
                                id: schedule.handyman_id,
                                name: schedule.full_name,
                                email: schedule.email,
                                name_with_email: schedule.full_name + ' (' + schedule.email + ')',
                                schedule_date: schedule.schedule_date,
                                start_hour: schedule.start_hour,
                                end_hour: schedule.end_hour,
                                start_time: schedule.start_time,
                                end_time: schedule.end_time,
                                status: schedule.status,
                                schedule_id: schedule.id
                            });
                        }
                    }
                });
            });

            // Check if staff is edit then get the matched staff
            if(this.attachStaffWithProject.edit) {
                const matched = options.filter(option => projectUserIds.includes(option.id));
                this.attachStaffWithProject.staff = matched;
            }
            return options;
        },
        availableSchedules() {
            return this.$store.getters.getAvailableSchedules;
        },
        bookedSchedules() {
            return this.$store.getters.getBookedSchedules;
        },
        handymanSchedules() {
            return this.$store.state.availableSchedules;
        },
        updateProjectSchema() {
            return {
                projectCompletionNote: 'required'
            };
        },
        pendingInvoiceAmount() {
            return this.totalCost - this.totalInvoicedAmount;
        }
    },
    methods: {
        getProjectDetails() {
            let self = this;

            axios.get('/admin/projects/' + self.project.id)
                .then(response => {
                    self.isProcessing = false;
                    self.projectData = response.data.project;
                    self.projectUsers = response.data.project.users;
                    self.projectItems = response.data.project.items;
                    self.projectAdditionalItems = response.data.project.additional_items;
                    self.totalInvoicedAmount = response.data.invoiced_amount;
                    self.initSlider();
                });
        },
        prepareStaffOptions() {
            let self = this;
            this.attachStaffWithProject.staff = null;
            this.staffUsersOptions = [];

            const dateToFind = this.$dateTimeFormat(this.attachStaffWithProject.work_date, 'YYYY-MM-DD');
            Object.keys(this.handymanSchedules).forEach((handymanId) => {
                this.handymanSchedules[handymanId].forEach((schedule) => {
                    if (schedule.schedule_date === dateToFind) {
                        let exists = self.staffUsersOptions.some(function(option) {
                            return option.id === schedule.handyman_id;
                        });
                        // If it doesn't exist, push the new option
                        if (!exists) {
                            self.staffUsersOptions.push({
                                id: schedule.handyman_id,
                                name: schedule.full_name,
                                email: schedule.email,
                                name_with_email: schedule.full_name + ' (' + schedule.email + ')',
                                schedule_date: schedule.schedule_date,
                                start_hour: schedule.start_hour,
                                end_hour: schedule.end_hour,
                                start_time: schedule.start_time,
                                end_time: schedule.end_time,
                                status: schedule.status,
                                schedule_id: schedule.id
                            });
                        }
                    }
                });
            });
        },
        selectStaffUser(event, index) {

            // Check if staff is not null then get the count of staff
            if(this.attachStaffWithProject.staff) {
                this.attachStaffWithProject.labour_cost = this.attachStaffWithProject.staff.length * this.projectData.average_staff_cost;
            }
        },
        removeStaffUser(event, index) {
            if(this.attachStaffWithProject.staff) {
                this.attachStaffWithProject.labour_cost = this.attachStaffWithProject.staff.length * this.projectData.average_staff_cost;
            }
        },
        addProjectStaff() {
            let self = this;

            self.isProcessing = true;
            // Prepare post URL add/edit
            let postUrl = '/admin/projects/attach-staff';
            if(this.attachStaffWithProject.edit) {
                postUrl = '/admin/projects/update-staff';
            }

            axios.post(postUrl, {
                project_id: self.project.id,
                staff: self.attachStaffWithProject
            }).then(response => {
                self.isProcessing = false;
                if (response.data.status === 'success') {
                    self.getProjectDetails();

                    // Hide the modal
                    $("#addStaffModal").modal("hide");

                    self.attachStaffWithProject = {edit: false,user_ids: [],user_id: null,name: '',email: '',amount: '',discount: '',labour_cost: '',tax: '',total_amount: '',work_date: new Date(),staff: null};

                    self.projectStaffDataTable();
                }
            });
        },
        //Show add staff modal on click
        showAddStaffModal() {
            this.attachStaffWithProject = {
                edit: false,
                user_ids: [],
                user_id: null,
                name: '',
                email: '',
                amount: '',
                discount: '',
                labour_cost: '',
                tax: '',
                total_amount: '',
                work_date: new Date().toISOString(),
                staff: null,
                batch: '',
                description: ''
            };

            this.$store.dispatch('fetchAvailableSchedules', true);
            this.$store.dispatch('fetchBookedSchedules');

            // Show add staff modal
            $('#addStaffModal').modal('show');
        },
        editStaff(item) {
            console.log(item);
            let idsAsNumbers = [];
            if(item.user_count > 0) {
                let userIds = item.user_ids.split(',');

                // Convert IDs in the array to integers for comparison
                idsAsNumbers = userIds.map((id) => parseInt(id, 10));
            }

            this.attachStaffWithProject.edit = true;
            this.attachStaffWithProject.user_ids = idsAsNumbers;
            this.attachStaffWithProject.staff_ids = item.staff_user_ids.split(',');
            this.attachStaffWithProject.work_date = item.work_date;
            this.attachStaffWithProject.total_amount = parseFloat(item.labour_cost);
            this.attachStaffWithProject.labour_cost = parseFloat(item.labour_cost).toFixed(2);
            this.attachStaffWithProject.batch = item.batch;
            this.attachStaffWithProject.description = item.description;

            this.$store.dispatch('fetchAvailableSchedules', {included_booked: true, user_ids: idsAsNumbers});
            this.$store.dispatch('fetchBookedSchedules');

            // Show add staff modal
            $('#addStaffModal').modal('show');
        },
        addMoreMaterial() {
            this.attachItemWithProject.push({
                service_id: '',
                service_name: '',
                amount: '',
                discount: '',
                Labour_cost: '',
                tax: '',
                total_amount: '',
                date: new Date(),
                material_cost: '',
                name: '',
                description: '',
            });
        },

        removeMaterial(index) {
            this.attachItemWithProject.splice(index, 1);
        },
        attachMaterialWithProject() {
            let self = this;
            self.isProcessing = true;
            axios.post('/admin/projects/attach-materials', {
                project_id: self.project.id,
                materials: self.attachItemWithProject
            }).then(response => {
                self.isProcessing = false;
                if (response.data.status === 'success') {
                    self.getProjectDetails();
                    // Hide the modal
                    $("#attachMaterialsModal").modal("hide");

                    // Reset the form
                    self.attachItemWithProject = [{service_id: '',service_name: '',amount: '',discount: '',labour_cost: '',tax: '',total_amount: '',date: new Date(),material_cost: '',name: '',description: ''}];

                    self.projectMaterialsTable();
                }
            });
        },
        addMoreAdditionalMaterial() {
            this.addExtraItems.items.push({
                name: '',
                description: '',
                date: new Date(),
                material_cost: '',
                description: ''
            });
        },

        removeAdditionalMaterial(index) {
            this.addExtraItems.items.splice(index, 1);
        },
        attachAdditionalMaterialWithProject() {
            let self = this;
            self.isProcessing = true;

            let postData = {
                project_id: self.project.id,
                files: self.addExtraItems.files,
                materials: self.addExtraItems.items
            };
            const config = {
                headers: { 'content-type': 'multipart/form-data' }
            }

            axios.post('/admin/projects/attach-additional-materials', postData, config)
                .then(response => {
                    self.isProcessing = false;
                    if (response.data.status === 'success') {
                        self.getProjectDetails();
                        // Hide the modal
                        $("#additionalMaterialsModal").modal("hide");

                        // Clear file selection
                        self.$refs.fileInput.value = '';

                        // Reset the form
                        self.addExtraItems = {files: [], items: [{name: '',description: '',date: new Date(),material_cost: ''}]};

                        self.projectExtraApprovedTable();
                    }
                });
        },
        onFileChange(event) {
            for (let file of event.target.files) {
                try {
                    let reader = new FileReader();

                    // Display the image preview
                    reader.onload = (e) => {
                        // Append the file to the files array for preview
                        //e.target.result
                    }
                    reader.readAsDataURL(file); // Not sure if this will work in this context.
                    this.addExtraItems.files.push(file);
                } catch {}
            }
        },
        async projectStaffDataTable() {
            this.staffDataTableObj.loading = true;
            let params = {
                project_id: this.project.id,
                per_page: this.staffDataTableObj.serverOptions.rowsPerPage,
                page: this.staffDataTableObj.serverOptions.page,
                sort_by: this.staffDataTableObj.serverOptions.sortBy,
                sort_type: this.staffDataTableObj.serverOptions.sortType
            };

            await axios.post('/admin/projects/get-staff-list', params)
                .then(response => {
                    this.staffDataTableObj.items = response.data.items;
                    this.staffDataTableObj.totalItems = response.data.totalItems;
                })
                .finally(() => {
                    this.staffDataTableObj.loading = false;
                });
        },
        deleteStaffItem(item) {
            Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    // Delete the material
                    axios.post('/admin/projects/delete-staff', {
                        staff_user_ids: item.staff_user_ids,
                        batch: item.batch,
                        project_id: item.project_id,
                        work_date: item.work_date
                    })
                        .then(response => {
                            if (response.data.status === 'success') {
                                this.getProjectDetails();
                                this.projectStaffDataTable();
                            }
                        })
                        .catch(error => {
                            console.log(error);
                        });
                }
            })
        },
        async projectMaterialsTable() {
            // Enable loading
            this.materialsDataTableObj.loading = true;
            let params = {
                project_id: this.project.id,
                per_page: this.materialsDataTableObj.serverOptions.rowsPerPage,
                page: this.materialsDataTableObj.serverOptions.page,
                sort_by: this.materialsDataTableObj.serverOptions.sortBy,
                sort_type: this.materialsDataTableObj.serverOptions.sortType
            };
            await axios.post('/admin/projects/get-material-list', params)
                .then(response => {
                    this.materialsDataTableObj.items = response.data.items;
                    this.materialsDataTableObj.totalItems = response.data.totalItems;
                })
                .finally(() => {
                    this.materialsDataTableObj.loading = false;
                });
        },
        showAddMaterialModal() {
            // Reset the object
            this.attachItemWithProject[0].id = '';
            this.attachItemWithProject[0].amount = '';
            this.attachItemWithProject[0].total_amount = '';
            this.attachItemWithProject[0].material_cost = '';
            this.attachItemWithProject[0].description = '';

            // Show add material modal
            $('#attachMaterialsModal').modal('show');
        },
        editMaterial(item) {
            this.attachItemWithProject[0].id = item.id;
            this.attachItemWithProject[0].amount = item.amount;
            this.attachItemWithProject[0].total_amount = item.total_amount;
            this.attachItemWithProject[0].material_cost = parseFloat(item.total_amount).toFixed(2);
            this.attachItemWithProject[0].date = item.created_at;
            this.attachItemWithProject[0].description = item.description;

            // Show add material modal
            $('#attachMaterialsModal').modal('show');
        },
        deleteMaterial(item) {
            // Display sweet alert
            Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    // Delete the material
                    axios.post('/admin/projects/delete-material', {id: item.id, project_id: item.project_id})
                        .then(response => {
                            if (response.data.status === 'success') {
                                this.projectMaterialsTable();
                            }
                        })
                        .catch(error => {
                            console.log(error);
                        });
                }
            })
        },
        async projectExtraApprovedTable() {
            this.extraApprovedDataTableObj.loading = true;
            let params = {
                project_id: this.project.id,
                per_page: this.extraApprovedDataTableObj.serverOptions.rowsPerPage,
                page: this.extraApprovedDataTableObj.serverOptions.page,
                sort_by: this.extraApprovedDataTableObj.serverOptions.sortBy,
                sort_type: this.extraApprovedDataTableObj.serverOptions.sortType
            };

            await axios.post('/admin/projects/get-approved-list', params)
                .then(response => {
                    this.extraApprovedDataTableObj.items = response.data.items;
                    this.extraApprovedDataTableObj.totalItems = response.data.totalItems;
                })
                .finally(() => {
                    this.extraApprovedDataTableObj.loading = false;
                });
        },
        showAddApprovedItemModal() {
            // Reset the object
            this.addExtraItems.items[0].id = '';
            this.addExtraItems.items[0].name = '';
            this.addExtraItems.items[0].description = '';
            this.addExtraItems.items[0].material_cost = '';
            this.addExtraItems.items[0].date = new Date();
            this.addExtraItems.items[0].description = '';

            // Show add material modal
            $('#additionalMaterialsModal').modal('show');
        },
        editApprovedItem(item) {
            this.addExtraItems.items[0].id = item.id;
            this.addExtraItems.items[0].name = item.name;
            this.addExtraItems.items[0].description = item.description;
            this.addExtraItems.items[0].material_cost = parseFloat(item.total_price).toFixed(2);
            this.addExtraItems.items[0].date = item.created_at;
            this.addExtraItems.items[0].description = item.description;

            // Show add material modal
            $('#additionalMaterialsModal').modal('show');
        },
        deleteApprovedItem(item) {
            // Display sweet alert
            Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    // Delete the material
                    axios.post('/admin/projects/delete-approved-item', {id: item.id, project_id: item.project_id})
                        .then(response => {
                            if (response.data.status === 'success') {
                                this.projectExtraApprovedTable();
                            }
                        })
                        .catch(error => {
                            console.log(error);
                        });
                }
            })
        },
        prepareImageSource(imgObj) {
            if (imgObj.document_type === 'image') {
                // Check if call for recent uploaded file
                if (imgObj.uploaded) {
                    return imgObj.document;
                }
                else if (typeof imgObj.document !== 'undefined') {
                    return this.$baseUrl + "/uploads/projects/" + imgObj.document;
                }
                else {
                    return this.$baseUrl + "/uploads/projects/" + imgObj.document;
                }
            }
            else if(imgObj.document_type === 'video') {
                return this.$baseUrl + "/images/svg/file-video.svg";
            }
            else if(imgObj.document_type === 'zip') {
                return this.$baseUrl + "/images/svg/file-archive.svg";
            }
            else {
                return this.$baseUrl + "/images/svg/file-text.svg";
            }
        },
        getImageUrl(img) {
             if (img.stored_name) {
                 return this.$s3RootUrl + "/project/" + img.stored_name;
             }
             return img.url;
        },
        getImagePreview(img) {
            if (img.file_type === 'image') {
                return this.getImageUrl(img);
            } else if (img.file_type === 'video') {
                return this.$baseUrl + '/images/svg/file-video.svg';
            } else if (img.file_type === 'pdf') {
                return this.$baseUrl + '/images/svg/file-pdf.svg';
            }
            return this.$baseUrl + '/images/svg/file-text.svg';
        },
        initSlider() {
            setTimeout(() => {
                if (typeof GLightbox !== 'undefined') {
                    GLightbox({
                        selector: '.order-img-slides',
                        touchNavigation: true,
                        loop: false,
                        autoplayVideos: true
                    });
                }
            }, 1000);
        },
        getHandymanBookedSchedules() {
            this.$store.dispatch('fetchBookedSchedules');
        },
        showMarkCompleteProjectModal() {
            $('#markProjectCompleteModal').modal('show');
        },
        markProjectComplete() {
            let self = this;
            this.isProcessing = true;
            axios.post('/api/admin/mark-project-complete', {
                project_id: self.project.id,
                comment: self.projectCompletionNote
            }).then(response => {
                if (response.data.status === 'success') {
                    self.getProjectDetails();
                    // Hide the modal
                    $("#markProjectCompleteModal").modal("hide");
                }
            }).finally(() => {
                self.isProcessing = false;
            });

        },
        handleNumberInput(event, index, type) {
            let value = event.target.value;
            const regex = /^\d*\.?\d{0,2}$/; // Allow numbers with up to two decimal places
            // Remove non-numeric characters
            value = value.replace(/[^0-9.]/g, '');

            if(type === 'material') {
                if (regex.test(value)) {
                    this.attachItemWithProject[index].material_cost = value;
                }
                else {
                    this.attachItemWithProject[index].material_cost = '';
                }
            }
            else if(type === 'additionalItem') {
                if (regex.test(value)) {
                    this.addExtraItems.items[index].material_cost = value;
                }
                else {
                    this.addExtraItems.items[index].material_cost = '';
                }
            }
            else if(type === 'staff') {
                if (regex.test(value)) {
                    this.attachStaffWithProject.labour_cost = value;
                }
                else {
                    this.attachStaffWithProject.labour_cost = '';
                }
            }
        },
        async getHandymanAvailable() {
            let params = {
                type: 'project',
                booking_date: this.dataTimeFormat(this.attachStaffWithProject.work_date, 'YYYY-MM-DD'),
                start_time: { hours: '00', minutes: '00' },
                end_time: { hours: '23', minutes: '59' },
            };
            let users = await this.getHandymanForTaskAssignment(params);

            //Check if user is empty then empty the handyman_ids
            if (users.length == 0) {
                this.attachStaffWithProject.staff = [];
            }
            //Prepare the options
            this.handymanList = users.map(user => ({
                id: user.id,
                text: user.name,
                name: user.name,
            }));
        },
    },
    watch: {
        'attachStaffWithProject.work_date': function(newVal, oldVal) {
            this.prepareStaffOptions();
            this.getHandymanAvailable();
        },
        /* 'materialsDataTableObj.serverOptions': {
            handler: function(newVal, oldVal) {
                console.log(newVal);
            },
            deep: true
        } */
    }
}
</script>
